
import { computed, SetupContext } from "vue";

import { GameConfigObj, GameSessionInput } from "types/gameSession";
import { useSubmitGameForm } from "composables/useSubmitGameForm";

import { AutoCompleteChip } from "components/molecules";
import { BaseDialog, BaseText, BaseButton } from "components/atoms";
import SelectDropdown, {
  OptionsI,
} from "components/molecules/SelectDropdown.molecule.vue";
import { Player } from "types/player";

interface Events {
  "on-game-submit": GameSessionInput;
}

interface Props {
  gameConfig: GameConfigObj;
}

export default {
  name: "SubmitGameDialog",
  components: {
    BaseDialog,
    SelectDropdown,
    AutoCompleteChip,
    BaseText,
    BaseButton,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    gameConfig: {
      type: Object as () => GameConfigObj,
      required: true,
      default: {},
    },
    playersOption: {
      type: Array as () => Player[],
      required: true,
      default: [],
    },
  },
  setup(props: Props, { emit }: SetupContext) {
    // Use Composable
    const {
      gameName,
      players,
      onTagSelection,
      validateInputs,
    } = useSubmitGameForm(props.gameConfig);

    // Handle on Game Select
    const onGameSelect = (value: OptionsI) => {
      gameName.value = value;
    };

    // Handle on game session Submit
    const onSubmit = () => {
      // Validate form's input
      const gameSessionInfo = validateInputs();

      // If valid, emit event
      if (gameSessionInfo) {
        emit("on-game-submit", gameSessionInfo);
      }
    };

    // Build the select options with the correct format
    const selectOptions = computed(() =>
      Object.keys(props.gameConfig).map((gameId) => ({
        id: gameId,
        label: gameId.toUpperCase(),
      }))
    );

    return {
      gameName,
      players,
      onGameSelect,
      onTagSelection,
      onSubmit,
      selectOptions,
    };
  },
  emits: ["on-game-submit"],
};
